import React, { useEffect, useState } from "react";
import {
  FaWhatsapp,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaPhoneAlt,
} from "react-icons/fa";
import { BsGrid3X3GapFill } from "react-icons/bs"; // ✅ main toggle icon
import { CiGrid2H } from "react-icons/ci";



const FloatingBar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // ✅ NEW (open/close social icons)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) setIsVisible(true);
      else setIsVisible(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const items = [
    {
      name: "WhatsApp",
      href: "https://wa.me/917904550032",
      icon: <FaWhatsapp />,
      color: "bg-[#25D366]",
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/mbwtech",
      icon: <FaInstagram />,
      color: "bg-[#E4405F]",
    },
    {
      name: "Facebook",
      href: "https://www.facebook.com/MBWTechimpexPvtLtd",
      icon: <FaFacebookF />,
      color: "bg-[#1877F2]",
    },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/in/mbw-techimpex-9062b925b",
      icon: <FaLinkedinIn />,
      color: "bg-[#0A66C2]",
    },
    // {
    //   name: "Phone",
    //   href: "tel:+91 98408 86487",
    //   icon: <FaPhoneAlt />,
    //   color: "bg-[#0EA5E9]",
    // },
  ];

  return (
    <div
      className={`fixed right-5 bottom-28 flex flex-col gap-3 z-50 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
    >

      {/* ✅ MAIN TOGGLE BUTTON */}


      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle social contact bar"
          className="fixed right-4 top-1/2 -translate-y-1/2 w-12 h-12 
                        bg-[#4F46E5] text-white rounded-full flex items-center
                        justify-center shadow-xl hover:scale-110 transition-all group"
        >
          <CiGrid2H className="text-xl" />

          {/* 🔥 WORKING CLICK ME TOOLTIP */}
          <span className="
                absolute 
                right-14 
                top-1/2 
                -translate-y-1/2 
                bg-gray-900 
                text-white 
                text-xs 
                py-1 
                px-2 
                rounded-md 
                opacity-0 
                group-hover:opacity-100 
                group-hover:translate-x-0 
                translate-x-2 
                transition-all 
                duration-200 
                whitespace-nowrap
                pointer-events-none
              ">
            Click Me
          </span>
        </button>
      </div>


      {/* ✅ SOCIAL ICONS (Show only when isOpen = true) */}
      {isOpen &&
        items.map((item, index) => (
          <a
            key={item.name}
            href={item.href}
            target={item.href.startsWith("tel:") ? "_self" : "_blank"}
            rel="noreferrer"
            className={`group  px-5 w-11 h-11 ${item.color} text-white rounded-full flex items-center justify-center shadow-lg 
              transform transition-all duration-500 ease-out hover:scale-110 hover:shadow-2xl relative`}
            style={{
              transitionDelay: `${index * 0.15}s`, // stagger animation
            }}
            aria-label={item.name}
          >
            <span className="text-xl">{item.icon}</span>

            {/* Label on Hover */}
            <span className="absolute right-14 bg-gray-900 text-white text-xs py-1 px-2 rounded-md 
              opacity-0 group-hover:opacity-100 group-hover:translate-x-0 translate-x-2 
              transition-all duration-200 whitespace-nowrap pointer-events-none">
              {item.name}
            </span>
          </a>
        ))}
    </div>
  );
};

export default FloatingBar;
